import { FlowGraphBlock } from "core/FlowGraph/flowGraphBlock";
import { RichTypeAny, RichTypeString } from "core/FlowGraph/flowGraphRichTypes.pure";
/**
 * Resolves a runtime object to its owning glTF node reference.
 * @param context active FlowGraph context
 * @param value runtime object, usually a picked primitive
 * @returns the owning node reference or the null reference
 */
export function GetInteractivityObjectReference(context, value) {
    let object = value;
    while (object) {
        const candidate = context.getObjectReference(object, "nodes");
        if (candidate?.startsWith("/nodes/")) {
            return candidate;
        }
        object = object.parent;
    }
    return "";
}
/**
 * Converts a runtime object into the opaque reference used by KHR_interactivity.
 */
export class FlowGraphObjectReferenceBlock extends FlowGraphBlock {
    constructor(config) {
        super(config);
        this.object = this.registerDataInput("object", RichTypeAny);
        this.value = this.registerDataOutput("value", RichTypeString, "");
    }
    /** @internal */
    _updateOutputs(context) {
        this.value.setValue(GetInteractivityObjectReference(context, this.object.getValue(context)), context);
    }
    /** @returns the serialized class name */
    getClassName() {
        return "FlowGraphObjectReferenceBlock";
    }
}
//# sourceMappingURL=flowGraphObjectReferenceBlock.js.map